// plugins/safe-title.js    （Vue 2 全局指令）
import Vue from 'vue';

function truncateText(str, maxLength = 1000) {
  if (!str) return '';
  if (str.length <= maxLength) return str;

  // 先取前 maxLength 个字符
  let truncated = str.slice(0, maxLength);

  // 如果不是以空格或标点结尾，往前找到最近的空格
  const lastSpace = truncated.lastIndexOf(' ');
  if (lastSpace > 0) {
    truncated = truncated.slice(0, lastSpace);
  }

  return truncated + '…';
}


function sanitizeToText(raw) {
  if (raw === null || raw === undefined) return '';
  // 用临时 div 解析 HTML，然后取 textContent 来去掉标签并解码实体
  const tmp = document.createElement('div');
  // 将 raw 转为字符串以避免错误
  tmp.innerHTML = String(raw);
  // textContent 会返回不含标签的文本
  return (tmp.textContent || tmp.innerText || '').trim();
}

function applyTitle(el, value, modifiers = {}) {
  if (value === null || value === undefined || value === '') {
    const fallback = sanitizeToText(el.innerHTML || '');
    if (fallback) {
      const truncated = truncateText(fallback);
      el.setAttribute('title', truncated);
      el.setAttribute('aria-label', truncated);
      el.dataset.safeTitle = truncated;
      return;
    }
    el.removeAttribute('title');
    el.removeAttribute('aria-label');
    delete el.dataset.safeTitle;
    return;
  }

  let text;
  if (modifiers && modifiers.raw) {
    text = String(value);
  } else {
    text = sanitizeToText(value);
  }

  // 加上截断逻辑
  text = truncateText(text);

  if (text) {
    el.setAttribute('title', text);
    el.setAttribute('aria-label', text);
    el.dataset.safeTitle = text;
  } else {
    el.removeAttribute('title');
    el.removeAttribute('aria-label');
    delete el.dataset.safeTitle;
  }
}

Vue.directive('safe-title', {
  bind(el, binding) {
    // 初次绑定
    applyTitle(el, binding.value, binding.modifiers);

    // 可选：当元素内文本动态变化（非通过指令）时自动更新 title
    // 这里设置一个 MutationObserver （只在需要时启用）
    const observer = new MutationObserver(() => {
      // 只有在指令没有传值时才用元素内部内容作为 title
      if (binding.value === undefined || binding.value === null || binding.value === '') {
        applyTitle(el, null, binding.modifiers);
      }
    });
    observer.observe(el, { childList: true, characterData: true, subtree: true });

    // 将 observer 引用保存到元素上以便 unbind 时清理
    el.__safeTitleObserver = observer;
  },
  update(el, binding) {
    // 当绑定的值变化时更新 title
    // 如果只是修饰符变化（理论上不常见），也会重新应用
    if (binding.value !== binding.oldValue || JSON.stringify(binding.modifiers) !== JSON.stringify(binding.old && binding.old.modifiers)) {
      applyTitle(el, binding.value, binding.modifiers);
    }
  },
  unbind(el) {
    // 清理 observer
    if (el.__safeTitleObserver) {
      el.__safeTitleObserver.disconnect();
      delete el.__safeTitleObserver;
    }
  }
});
